import vxAutoSuggest from '../components/b2c/search-browse/vx-auto-suggest/vx-auto-suggest.vue';
import vxListPage from '../components/b2c/search-browse/vx-list-page/vx-list-page.vue';
import vxSearchResult from '../components/b2c/search-browse/vx-search-result/vx-search-result.vue';


const searchBrowseModule = {
  components: {
    vxAutoSuggest,
    vxListPage,
    vxSearchResult,
  },
};

export default searchBrowseModule;



// WEBPACK FOOTER //
// ./src/modules/search-browse-b2c.js